import { render, staticRenderFns } from "./CreateRouteOfAdministation.vue?vue&type=template&id=d3481fb0&scoped=true&"
import script from "./CreateRouteOfAdministation.vue?vue&type=script&lang=js&"
export * from "./CreateRouteOfAdministation.vue?vue&type=script&lang=js&"
import style0 from "./CreateRouteOfAdministation.vue?vue&type=style&index=0&id=d3481fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3481fb0",
  null
  
)

export default component.exports